import {
	faTachometerAlt,
	faChalkboardTeacher,
	faSitemap,
	faUsers,
	faBuilding,
	faUsersClass,
	faTags,
	faPlus,
	faGraduationCap,
	faMountain,
	faUserFriends,
	faList,
	faCog,
} from '@fortawesome/pro-light-svg-icons'

// !IMPORTANT keep order of roles in order or rank
// this order is used to check the user auth level
export const ROLES = [
	{ value: 'admin', label: 'Admin' },
	//{ value: 'developer', label: 'Developer (Master challenge)' }, // not implemented yet
	{ value: 'organisation-admin', label: 'Organisation admin' },
	{ value: 'space-admin', label: 'Space admin' },
	{ value: 'company-owner', label: 'Company owner' },
	{ value: 'student', label: 'Student' },
	{ value: 'developer_external', label: 'Developer (External party)' },
]

export const USER_STATES = [
	{ value: 0, label: 'Inactive' },
	{ value: 1, label: 'Active' },
]

export const ORGANISATION_STATES = [
	{ value: 0, label: 'Inactive' },
	{ value: 1, label: 'Active' },
]

export const COMPANY_STATES = [
	{ value: 0, label: 'Inactive' },
	{ value: 1, label: 'Active' },
]

export const CHALLENGE_STATES = [
	{ value: 0, label: 'Unapproved', slug: 'unapproved' },
	{ value: 1, label: 'Approved', slug: 'approved' },
	{ value: 2, label: 'Pending approval', slug: 'pending-approval' },
]

export const CHALLENGE_SPACE_STATES = [
	{ value: 0, label: 'Inactive' },
	{ value: 1, label: 'Active' },
]

export const CHALLENGE_SPACE_VISIBILITY_STATES = [
	{ value: true, label: 'Public' },
	{ value: false, label: 'Private' },
]

export const CHALLENGE_SPACE_EXPIRATION_STATES = [
	{ value: 0, label: 'Active' },
	{ value: 1, label: 'Expired' },
]

export const CHALLENGE_SPACE_APPLICATION_TYPES = [
	{ value: 'individual', label: 'Individual' },
	{ value: 'team', label: 'Team' },
]

export const CHALLENGE_SPACE_PHASES = [
	{
		value: 'challenge_submission',
		label: 'Challenge submission & Team registration',
	},
	{
		value: 'challenge_submission_tf',
		label: 'Challenge submission & Team formation',
	},
	{ value: 'team_formation', label: 'Team formation' },
	{ value: 'challenge_ranking', label: 'Challenge ranking' },
	{ value: 'student_ranking', label: 'Team ranking' },
	{ value: 'matching', label: 'Matching' },
	{ value: 'evaluation', label: 'Evaluation' },
]

export const CHALLENGE_SPACE_SORT_OPTIONS = [
	{ value: '-created_at', label: 'Newest' },
	{ value: 'challenge_start_date', label: 'Start date' },
	{
		value: 'challenge_submit_deadline_expired,challenge_submit_deadline',
		label: 'Submit deadline',
	},
]

export const MAILING_RECIPIENTS = [
	{ value: 'team', label: 'All teams' },
	{ value: 'challenge', label: 'All challenge owners' },
]

export const MAILING_CHALLENGE_FILTERS = [
	{
		value: 'challenge_approved',
		label: 'have approved challenge(s)',
	},
	{
		value: 'challenge_pending_approved',
		label: 'have challenge(s) that are pending for approval',
	},
	{
		value: 'challenge_disapproved',
		label: 'have disapproved challenge(s)',
	},
	{
		value: 'challenge_with_ranking',
		label: 'have submitted their team ranking',
	},
	{
		value: 'challenge_without_ranking',
		label: 'have not submitted their team ranking',
	},
	{
		value: 'challenge_not_selected_by_team',
		label: 'have not been selected by any team',
	},
	{
		value: 'challenge_has_match',
		label: 'have been matched to a team',
	},
	{
		value: 'challenge_has_no_match',
		label: 'have not been matched to a team',
	},
]

export const MAILING_TEAM_FILTERS = [
	{
		value: 'team_with_ranking',
		label: 'have submitted their challenge ranking',
	},
	{
		value: 'team_without_ranking',
		label: 'have not submitted their challenge ranking',
	},
	{
		value: 'team_has_match',
		label: 'have been matched to a challenge',
	},
]

export const TEAM_FORMATION_CONFIG_QUESTION_TYPES = [
	{
		value: 'select',
		label: 'Select',
		description: 'Single value dropdown',
	},
	{
		value: 'scale',
		label: 'Scale',
		description: 'E.g. fully disagree - fully agree',
	},
	{
		value: 'ranking',
		label: 'Ranking',
		description: 'E.g. a top 5 of colours',
	},
	{
		value: 'text',
		label: 'Open question',
		description: 'Get input from students (max words)',
	},
]

export const TEAM_FORMATION_CONFIG_RANKING_OPTIONS = [
	{
		value: 2,
		label: 'Top 2',
	},
	{
		value: 3,
		label: 'Top 3',
	},
	{
		value: 4,
		label: 'Top 4',
	},
	{
		value: 5,
		label: 'Top 5',
	},
	{
		value: 6,
		label: 'Top 6',
	},
	{
		value: 7,
		label: 'Top 7',
	},
	{
		value: 8,
		label: 'Top 8',
	},
	{
		value: 9,
		label: 'Top 9',
	},
	{
		value: 10,
		label: 'Top 10',
	},
	{
		value: 11,
		label: 'Top 11',
	},
	{
		value: 12,
		label: 'Top 12',
	},
	{
		value: 13,
		label: 'Top 13',
	},
	{
		value: 14,
		label: 'Top 14',
	},
	{
		value: 15,
		label: 'Top 15',
	},
	{
		value: 16,
		label: 'Top 16',
	},
	{
		value: 17,
		label: 'Top 17',
	},
	{
		value: 18,
		label: 'Top 18',
	},
	{
		value: 19,
		label: 'Top 19',
	},
	{
		value: 20,
		label: 'Top 20',
	},
]

export const GENERAL_QUESTION_TYPES = [
	{
		value: 'select',
		label: 'Select',
		description: 'Single value dropdown',
	},
	{
		value: 'select.multi',
		label: 'Multiselect',
		description: 'Multiple choice dropdown',
	},
	{
		value: 'scale',
		label: 'Scale',
		description: 'E.g. fully disagree - fully agree',
	},
	{
		value: 'ranking',
		label: 'Ranking',
		description: 'E.g. a top 5 of colours',
	},
	{
		value: 'text',
		label: 'Open question',
		description: 'Get flexible input (max words)',
	},
]

export const OPEN_CHALLENGE_TYPES_SELECTABLE = [
	{
		value: 'global',
		label: 'Global',
	},
	{
		value: 'organisation',
		label: 'Organisation',
	},
]

export const USER_TYPE_SELECT = [
	{ value: 'internal', label: 'Internal' },
	{ value: 'external', label: 'External' },
]

export const UNAPPROVE_CHALLENGE_REASONS = [
	{
		value: 'not_sufficiently_match',
		label: 'Your challenge does not sufficiently match the aim of the course.',
		text: 'The reason for this is that your challenge does not sufficiently match the aim of the course.',
	},
	{
		value: 'received_too_many_challenges',
		label: 'We received too many challenges.',
		text: 'The reason for this is that we received too many challenges.',
	},
	{
		value: 'better_fit_with_other_challenges',
		label:
			'We received too many challenges, and after reviewing all challenges, we saw a better fit with other challenges.',
		text: 'The reason for this is that we received too many challenges, and after reviewing all challenges, we saw a better fit with other challenges.',
	},
	{
		value: 'other',
		label: 'Other',
		text: '',
	},
]

export const DEFAULT_EVALUATION_QUESTIONS = [
	{
		attributes: {
			title: 'In general, this challenge was well organized',
			type: 'scale',
			options: { min: 1, max: 5 },
		},
	},
	{
		attributes: {
			title: "I'm happy with the team that was assigned to my challenge",
			type: 'scale',
			options: { min: 1, max: 5 },
		},
	},
	{
		attributes: {
			title: 'The final work is of high quality',
			type: 'scale',
			options: { min: 1, max: 5 },
		},
	},
	{
		attributes: {
			title: 'I will implement most of the recommendations',
			type: 'scale',
			options: { min: 1, max: 5 },
		},
	},
	{
		attributes: {
			title:
				'I would recommend other companies to participate in this challenge',
			type: 'scale',
			options: { min: 1, max: 5 },
		},
	},
	{
		attributes: {
			title:
				'Will you ask one or more of the team members to help you out to (further) implement the recommendations?',
			type: 'select',
			options: {
				items: [
					{ label: 'Yes', value: 'yes' },
					{ label: 'Maybe', value: 'maybe' },
					{ label: 'No', value: 'no' },
					{ label: "Don't know yet", value: 'dont_know_yet' },
				],
			},
		},
	},
	{
		attributes: {
			title: 'May we contact you to participate in future challenges?',
			type: 'select',
			options: {
				items: [
					{ label: 'Yes', value: 'yes' },
					{ label: 'No', value: 'no' },
				],
			},
		},
	},
	{
		attributes: {
			title:
				'Anything else you want to share with us? Feedback? Questions? Etc',
			type: 'text',
			options: {},
		},
	},
	{
		attributes: {
			title:
				'Would be great if you could leave a review about this challenge that we can use in our communication (optional)',
			type: 'text',
			options: {},
		},
	},
]

export const accountMenuItems = [
	{
		url: '/account',
		name: 'Dashboard',
		icon: faTachometerAlt,
	},
	{
		url: '/account/challenge-spaces',
		name: 'Challenge spaces',
		icon: faChalkboardTeacher,
		disallowedRoles: ['developer_external'],
		children: [
			{
				url: '/account/challenge-spaces',
				name: 'Overview',
				icon: faChalkboardTeacher,
			},
			{
				url: '/account/challenge-spaces/new/setup',
				name: 'Add new space',
				icon: faPlus,
				allowedRole: ['admin', 'space-admin'],
			},
		],
	},
	{
		url: '/account/challenges',
		name: 'My challenges',
		icon: faMountain,
		allowedRole: ['company-owner'],
	},
	{
		url: '/account/teams',
		name: 'My teams',
		icon: faUserFriends,
		allowedRole: ['student'],
	},
	{
		url: '/account/organisation/users',
		name: 'Organisation',
		icon: faSitemap,
		allowedRole: ['admin', 'organisation-admin', 'space-admin'],
		children: [
			{
				url: '/account/organisation/users',
				allowedRole: ['admin', 'organisation-admin', 'space-admin'],
				name: 'Users',
				icon: faUsers,
			},
			{
				url: '/account/organisation/questions',
				name: 'Questions',
				icon: faList,
				allowedRole: ['admin', 'organisation-admin'],
			},
		],
	},
	{
		url: '/account/open-challenges',
		name: 'Open Challenges',
		icon: faMountain,
		allowedRole: ['admin', 'organisation-admin', 'space-admin'],
	},
	{
		url: '/account/management/users',
		name: 'Management',
		icon: faCog,
		allowedRole: ['admin'], // organisation admin?
		children: [
			{
				url: '/account/management/users',
				name: 'Users',
				icon: faUsers,
			},
			{
				url: '/account/management/companies',
				name: 'Companies',
				icon: faBuilding,
			},
			{
				url: '/account/management/organisations',
				name: 'Organisations',
				icon: faUsersClass,
			},
			{
				url: '/account/management/subjects',
				name: 'Subjects',
				icon: faTags,
			},
			{
				url: '/account/management/education-types',
				name: 'Education types',
				icon: faGraduationCap,
			},
			{
				url: '/account/management/challenges',
				name: 'Challenges',
				icon: faMountain,
			},
		],
	},
]

export const teamFormationPathConfig = {
	match_individuals_projects_roles: {
		label: 'Single team requirement + Challenge preferences',
		description:
			'Teams are formed based on 1 specific team requirement that is set for each challenge. Next to that, students can indicate their preferences for challenges. The algorithm will try to match students to their preferred challenges as much as possible.',
	},
	match_individuals_projects_roles_hill_climbing: {
		label: 'Perfect single team requirement + Challenge preferences',
		description:
			'Teams are formed based on 1 specific team requirement that is set for each challenge. Additionally, this algorithm expects a perfect distribution of students across all challenges for each requirement. All wanted answers for the team requirement should be fullfilled in the final distribution of students. Lastly, students can indicate their preferences for challenges. The algorithm will try to match students to their preferred challenges as much as possible.',
	},
	match_individuals_projects_preferences: {
		label: 'Team requirements + Challenge preferences',
		description:
			'Teams are formed based on one or multiple team requirements that are set for each challenge. Next to that, students can indicate their preferences for challenges. The algorithm will try to match students to their preferred challenges as much as possible.',
	},
	match_individuals_projects: {
		label: 'Challenge preferences',
		description:
			'Teams are formed initially based on their preferences for challenges. Secondly the teams will be optimized based on their answers to the team formation questions.',
	},
	match_individuals_projects_dont_link: {
		label: 'Challenge preferences without linking challenges',
		description:
			'Teams are formed initially based on their preferences for challenges but they will not be linked to the possible challenges. Secondly the teams will be optimized based on their answers to the team formation questions.',
	},
	match_individuals: {
		label: 'Individual matches',
		description:
			'Teams are formed out of individual students based on their answers from the team formation question list.',
	},
}
